export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <span className="font-heading text-2xl font-black text-accent-500 inline-block mb-4">UU漫画</span>
            <p className="text-sm text-background-400 leading-relaxed">
              UU漫画是专业的漫画追更平台，提供最新漫画更新追踪、连载漫画同步阅读和漫画更新提醒服务。
              免费漫画全集随时看，追漫必备，不再错过任何章节。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-100 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '追更榜单', href: '#ranking' },
                { label: '漫画索引', href: '#index' },
                { label: '焦点专题', href: '#carousel' },
                { label: '常见问题', href: '#faq' },
                { label: '更新动态', href: '#updates' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-100 mb-4">热门话题</h4>
            <div className="flex flex-col gap-2">
              {['漫画追更', '最新漫画更新', '连载漫画', '追更漫画', '免费漫画'].map((t) => (
                <a
                  key={t}
                  href="#topics"
                  className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {t}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              更多合作伙伴即将加入，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700/50 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 UU漫画 · 漫画追更 最新漫画更新 | 连载漫画 追漫必备
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#hero" className="hover:text-background-300 transition-colors cursor-pointer">首页</a>
            <a href="#contact" className="hover:text-background-300 transition-colors cursor-pointer">联系我们</a>
            <a href="#about" className="hover:text-background-300 transition-colors cursor-pointer">关于UU</a>
          </div>
        </div>
      </div>
    </footer>
  );
}